import React from "react";
import { Box, Grid, Skeleton } from "@mui/material";
import { dash } from "./dashboardTokens";

function Block({ height = 132 }) {
  return (
    <Skeleton variant="rounded" height={height} sx={{ borderRadius: dash.radiusLg, width: "100%" }} />
  );
}

export default function DashboardSkeleton() {
  return (
    <Box>
      <Box sx={{ mb: 3, pb: 2, borderBottom: `1px solid ${dash.border}` }}>
        <Skeleton variant="text" width={180} height={36} />
        <Skeleton variant="text" width="45%" height={22} sx={{ mt: 1 }} />
      </Box>
      <Grid container spacing={dash.gridGap} sx={{ mb: dash.sectionGap }}>
        {Array.from({ length: 8 }).map((_, i) => (
          <Grid item xs={12} sm={6} lg={3} key={i}>
            <Block />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={dash.gridGap} sx={{ mb: dash.sectionGap }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Block height={dash.chartMinHeight} />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={dash.gridGap}>
        {Array.from({ length: 3 }).map((_, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Block height={220} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
